import React, { useEffect, useRef, useState } from "react";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export default function MapLegend(props) {
	const { results, userParams, updateLevels=null, updateColors=null } = props;
	const { levels, cmap, range } = results;
	const [ width, setWidth ] = useState();
	const [ eachWidth, setEachWidth ] = useState();
    const [ levelLabels, setLevelLabels ] = useState(levels);
    const [ levelColors, setLevelColors ] = useState(cmap)
    const userPropLevels = userParams.clevels.filter(x => x != "");
	const ref = useRef(null);
	
	useEffect(() => {
 		const newLevelLabels = levelLabels;
        const newLevelColors = levelColors;
		// remove levels above or below range of values (i.e. unused colors), unless explicitly requested by client
		if (userPropLevels.length === 0) {
			if (newLevelLabels[newLevelLabels.length-1] >= range[1]) {
				newLevelLabels.pop();
				newLevelColors.pop();
			}
			if (newLevelLabels[0] < range[0]) {
				newLevelLabels.shift()
				newLevelColors.shift()
			}
		}
        setLevelLabels(newLevelLabels)
        setLevelColors(newLevelColors)
		//updateLevels(newLevelLabels});              /////////////////////////////////////////
		//updateColors(newLevelColors});              /////////////////////////////////////////
	}, [levels])

	useEffect(() => {
		if (ref) {
			const elemWidth = ref.current.offsetWidth;
			const defaultWidth = levelColors.length * 60;
			setWidth(Math.min(defaultWidth, elemWidth));
			setEachWidth(Math.min(defaultWidth, elemWidth)/levelColors.length);
		}
	},[levelColors.length]);

	return (
		<Stack direction="column" alignItems="center" ref={ref} sx={{ mt: 2 }}>
            <TableContainer sx={{ width: width, }}>
                <Table size="small" sx={{ p: 0, width: width }}>
                    <TableBody>
                        <TableRow>
                            {levelColors.map((color, i) => (
                                <TableCell key={i} sx={{ height: "28px", border: "1px solid gray", bgcolor: color, width: eachWidth }}></TableCell>
                            ))}
                        </TableRow>	
                    </TableBody>
                </Table>
            </TableContainer>

            <TableContainer sx={{ width: width }}>
                <Table size="small" sx={{ border: "0!important", p: 0, width: width }}>
                    <TableBody>
                        <TableRow>
                            <TableCell sx={{ border: 0, width: eachWidth/2 }}></TableCell>
                            {levelLabels.map((lv, i) => (
                                <TableCell key={i} align="center" sx={{ border: 0, p: 0, width: eachWidth }}>
                                    {lv}
                                </TableCell>
                            ))}
                            <TableCell sx={{ border: 0, width: eachWidth/2 }}></TableCell>
                        </TableRow>	
                    </TableBody>
                </Table>
            </TableContainer>
            <Typography 
                variant="caption"
                sx={{ m: 0 }}
            >
                <p>Range of values: {range[0]} to {range[1]}</p>
            </Typography>
		</Stack>
	);
}
